<template>
  <section class="section container pt-3">
    <full-calendar :options="calendarOptions" ref="full_calendar">
      <!-- <template v-slot:eventContent="arg">
        <pre>{{ arg }}</pre>
      </template> -->
    </full-calendar>
    <appointment-modal
      ref="appointment_modal"
      @success="refresh"
    ></appointment-modal>
  </section>
</template>

<script>
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { api_host, get, error_message, post } from "@/utils";
import AppointmentModal from "./appointment_modal/Index.vue";
import moment from "moment";

export default {
  name: "CalendarIndex",
  components: { FullCalendar, AppointmentModal },
  data() {
    let v = this;
    return {
      calendarOptions: {
        locale: v.$i18n.locale,
        customButtons: {
          refresh: {
            text: v.$t("refresh"),
            click: function () {
              v.refresh();
            },
          },
        },
        eventSources: [
          // your event source
          // {
          //   url: `${api_host}/calendar/event/all`, // use the `url` property
          //   color: "yellow", // an option!
          //   textColor: "black", // an option!
          // },
          {
            events: function (info, success, failure) {
              // console.log("events", info);
              get("/animal/appointment/all", {
                start_date: info.start,
                end_date: info.end,
              })
                .then((response) => {
                  let arr = response.map((event) => {
                    let evt = {
                      id: event.uuid,
                      title: event.patient.name,
                      start: event.start_date,
                      end: event.end_date,
                      allDay: false,
                      display: "block",
                      modul_evt: event,
                      color: event.settings.color,
                    };
                    return evt;
                  });
                  success(arr);
                })
                .catch((error) => {
                  error_message(error);
                  failure(error);
                });
            },
          },
        ],
        editable: true,
        nowIndicator: true,
        // now: true,
        buttonText: {
          today: v.$t("today"),
          month: v.$t("month"),
          week: v.$t("week"),
          day: v.$t("day"),
        },
        footerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        },
        headerToolbar: {
          left: "prev,next today refresh",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        },
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin],
        initialView: "dayGridMonth",
        dateClick: v.date_click,
        eventClick: v.event_click,
        eventChange: v.event_change,
      },
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    date_click: function (arg) {
      let v = this;
      v.$refs.appointment_modal.create_appointment(arg);
    },
    event_click: function (info) {
      let v = this;
      v.$refs.appointment_modal.edit_appointment(info.event._def.publicId);
    },
    event_change: function (info) {
      let v = this;
      post("/animal/appointment", {
        uuid: info.event._def.publicId,
        start_date: info.event.start,
        end_date: info.event.end,
      })
        .then(() => {
          v.refresh();
        })
        .catch((error) => {
          console.error(error);
          error_message(error);
        });
    },
    refresh() {
      let v = this;
      let api = v.$refs.full_calendar.getApi();
      api.refetchEvents();
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped>
.fc-view-harness {
  background-color: rgba(255, 255, 255, 0.1) !important;
}
</style>
